<template>
  <div v-if="service" class="p-16">
    <div class="max-w-3xl mx-auto space-y-8">
      <h3 class="uppercase text-center tracking-wider font-light">
        {{ service.name }}
      </h3>

      <div class="mt-16 flex items-baseline">
        <div class="bg-gray-100 p-3 ml-auto rounded">
          <div class="flex -mx-3 items-baseline">
            <div class="flex-1 px-3 border-r">
              <BaseButton success @click="createOrder"> Παραγγελία </BaseButton>
            </div>
            <div class="flex-1 px-8 py-2">Τελική Τιμή</div>
            <div class="w-24 px-4 font-medium text-right border-l">{{ totalPrice }} &euro;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import orderLinesMixin from '@/mixins/orderLinesMixin';

export default {
  name: 'ServiceIdView',
  mixins: [orderLinesMixin],
  props: {
    serviceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('ui/services', ['service']),
    totalPrice() {
      return this.orderLines.reduce((acc, cur) => acc + cur.price, 0);
    },
  },
  created() {
    this.setup();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mapActions('ui/services', ['fetchService']),
    ...mapMutations('ui/services', ['setCurrent']),
    async setup() {
      const { serviceId } = this;

      await this.fetchService({ serviceId });

      this.createOrderLineFromService(this.service);
    },
    createOrder() {
      window.localStorage.setItem('orderLines', JSON.stringify(this.orderLines));
      this.$router.push({
        name: 'accounts.orders.create',
        params: { ...this.$route.params },
      });
    },
  },
};
</script>
